if (!customElements.get('mobile-pdp-layout')) {
  customElements.define('mobile-pdp-layout', class MobilePdpLayout extends HTMLElement {
    connectedCallback() {
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.placements = [];
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.updateLayout = this.updateLayout.bind(this);
      this.mobile.addEventListener('change', this.updateLayout, { signal });
      document.addEventListener('shopify:section:load', this.updateLayout, { signal });
      document.addEventListener('shopify:section:reorder', this.updateLayout, { signal });
      this.updateLayout();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.restoreLayout();
    }

    moveBefore(node, target) {
      if (!node || !target || node === target || node.nextElementSibling === target) return;
      if (!this.placements.some((entry) => entry.node === node)) {
        const anchor = document.createComment('Original PDP content position');
        node.before(anchor);
        this.placements.push({ node, anchor });
      }
      target.before(node);
    }

    restoreLayout() {
      this.placements?.forEach(({ node, anchor }) => {
        // A section may have been replaced by the theme editor since it was moved.
        if (anchor.parentNode && node.parentNode) anchor.replaceWith(node);
        else anchor.remove();
      });
      this.placements = [];
    }

    updateLayout() {
      if (!this.mobile.matches) return this.restoreLayout();
      const pickup = this.querySelector('[data-pdp-pickup]');
      // Move secondary links only: the cart form and variant picker stay intact.
      ['sample_link', 'authenticity_badges', 'product_tags'].forEach((type) => {
        this.moveBefore(this.querySelector(`[data-pdp-secondary="${type}"]`), pickup);
      });
      const description = document.querySelector('[data-pdp-description]')?.closest('.shopify-section');
      const bundle = document.querySelector('[data-pdp-bundle]')?.closest('.shopify-section');
      if (description && bundle && description.parentNode === bundle.parentNode) {
        if (description.nextElementSibling !== bundle) {
          if (!this.placements.some((entry) => entry.node === bundle)) {
            const anchor = document.createComment('Original bundle position');
            bundle.before(anchor);
            this.placements.push({ node: bundle, anchor });
          }
          description.after(bundle);
        }
      }
    }
  });
}
